import React from "react";
import { Menu } from "@design-system/Menu/Menu.lib";

interface Props {
    onOpenSettings: () => void;
}

// 24px dots menu in the Details card header. Its single entry swaps the
// details panel for the field label & visibility editor.
export const FieldRowMenu: React.FC<Props> = ({ onOpenSettings }) => (
    <Menu.More aria-label="Section settings">
        <Menu.Item onClick={onOpenSettings}>Settings</Menu.Item>
    </Menu.More>
);
